import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { startGetBrandInformation } from "../actions/adsCampaigns";
import { ConfirmAlert } from "../components/Alerts/Alerts";
import { useTranslationApp } from "../lib/i18next";
import { useDispatchApp } from "../lib/redux";
import {
  getCompetitorScopeAlertCopy,
  getCompetitorScopeBlockReason,
  hasBrandContext,
} from "../utils/competitorScope/competitorScopeValidation";

const resolveBrandData = async ({ dispatch, brandInformation }) => {
  if (hasBrandContext(brandInformation)) {
    return brandInformation;
  }

  const response = await dispatch(startGetBrandInformation());
  return response.ok ? response.data || {} : {};
};

const showCompetitorScopeBlockAlert = async ({ blockReason, navigate, t }) => {
  const { titleKey, descriptionKey, confirmButtonKey, settingsPath } =
    getCompetitorScopeAlertCopy(blockReason);

  const response = await ConfirmAlert({
    title: t(titleKey),
    text: t(descriptionKey),
    showCancelButton: false,
    confirmButtonText: t(confirmButtonKey),
  });

  if (response.isConfirmed) {
    navigate(settingsPath);
  }
};

export const useCompetitorScopeGuard = ({ brandInformation } = {}) => {
  const dispatch = useDispatchApp();
  const navigate = useNavigate();
  const { t } = useTranslationApp();

  const onTryOpenCompetitorScope = useCallback(
    async ({ onOpen }) => {
      const brandData = await resolveBrandData({ dispatch, brandInformation });
      const blockReason = getCompetitorScopeBlockReason(brandData);

      if (blockReason) {
        await showCompetitorScopeBlockAlert({ blockReason, navigate, t });
        return;
      }

      onOpen?.();
    },
    [brandInformation, dispatch, navigate, t]
  );

  return { onTryOpenCompetitorScope };
};
